module.exports = new __parcel__URL__("Paras_logo.50f44cc1.svg").toString();